var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',[_vm._v(_vm._s(_vm.stocks))]),_vm._v(" "),_vm._l((_vm.stocks),function(stock,index){return _c('app-stock',{key:index,attrs:{"stock":stock}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2829bba9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/portfolio/Portfolio.vue
// module id = 35
// module chunks = 0